import useReveal from '../utils/useReveal';

/**
 * Animates its children into view on scroll (fade + rise). Honours reduced
 * motion (renders immediately). `as` lets callers pick the wrapper element,
 * `delay` staggers grouped reveals (in ms).
 */
export default function Reveal({
  as: Tag = 'div',
  className = '',
  delay = 0,
  children,
  ...rest
}) {
  const { ref, shown } = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${shown ? ' is-visible' : ''}${className ? ` ${className}` : ''}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
